import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '../shared/materials/materials.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { HsHomepageComponent } from './hs-homepage.component';
import { HsEventsComponent } from './hs-events/hs-events.component';

@NgModule({
  declarations: [HsHomepageComponent, HsEventsComponent],
  imports: [MaterialsModule, RouterModule, SharedModule, FormsModule],
  providers: [],
})
export class HsHomepageModule {}
